import PickUpUI from "./PickupUI.js";
import ScoreUI from "./score.js";
import BulletUI from "./BulletUI.js";
import GameOverUI from "./GameOverUI.js";

export { PickUpUI, ScoreUI, BulletUI, GameOverUI };
